var a = Object.defineProperty;
var f = (i, t, e) => t in i ? a(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var m = (i, t, e) => (f(i, typeof t != "symbol" ? t + "" : t, e), e);
import { j as r } from "./jsx-runtime-944c88e2.js";
import p from "react";
import { B as d } from "./Button-4c83e316.js";
import { R as h } from "./Ripple-5a8cf54c.js";
import { Icon as u } from "./icon.js";
import "./index-efd35e77.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
import "./theme-b013fa81.js";
class _ extends p.Component {
  constructor() {
    super(...arguments);
    m(this, "buttonRef", p.createRef());
  }
  get element() {
    var e, n;
    return (n = (e = this.buttonRef) == null ? void 0 : e.current) == null ? void 0 : n.element;
  }
  render() {
    const { iconName: e, type: n = "button", disableRipple: c, ...o } = this.props, s = o.themeColor || "primary", l = o.fillMode || "solid";
    return c ? /* @__PURE__ */ r.jsxs(
      d,
      {
        ...o,
        type: n,
        rounded: "medium",
        size: "medium",
        themeColor: s,
        fillMode: l,
        togglable: !0,
        ref: this.buttonRef,
        children: [
          e && /* @__PURE__ */ r.jsx(u, { icon: e, size: "lg", style: { paddingRight: "10px" } }),
          o.children
        ]
      }
    ) : /* @__PURE__ */ r.jsx(h, { children: /* @__PURE__ */ r.jsxs(
      d,
      {
        ...o,
        type: n,
        rounded: "medium",
        size: "medium",
        themeColor: s,
        fillMode: l,
        togglable: !0,
        ref: this.buttonRef,
        children: [
          e && /* @__PURE__ */ r.jsx(u, { color: "secondary", icon: e, size: "lg" }),
          e && o.children && /* @__PURE__ */ r.jsx("div", { style: { paddingRight: "10px", display: "inline" } }),
          o.children
        ]
      }
    ) });
  }
}
export {
  _ as Button
};
